<app-login-partner-container [bg]="bg">
  <div class="p-sm-5 p-3" logo>
    <app-partner-portal-logo class="d-block"></app-partner-portal-logo>
  </div>
  <div (keydown.enter)="$event.preventDefault()" class="form p-3 p-sm-5 shadow rounded-4">
    @if (type === 'manual') {
      @if (message) {
        <ngb-alert type="success" [dismissible]="false">{{
          message
        }}</ngb-alert>
      }
      @if (!message) {
        <label><b>{{ "USERNAME" | translate }}</b></label>
        <input type="text" class="form-control" [(ngModel)]="username" />
      }
      @if (!resetted) {
        <button
          class="btn btn-primary mt-2"
          (click)="resetPassword()"
          [disabled]="!username.length"
          >
          {{ "CONFIRM" | translate }}
        </button>
      }
    }
    @if (type === 'verify' && username) {
      <h4>{{ username }}</h4>
      <app-change-password-container
        #passwordContainer
        [hideCurrentPassword]="true"
      ></app-change-password-container>
      @if (!resetted) {
        <button
          class="btn btn-primary mt-2"
          (click)="sendNewPassword($event)"
          [disabled]="!passwordContainer.checkPasswordRequirements()"
          >
          {{ "CONFIRM" | translate }}
        </button>
      }
    }
    @if (type === 'verify' && error) {
      <ngb-alert type="danger" [dismissible]="false">{{ error }}</ngb-alert>
    }
    @if (type === 'verify_complete') {
      <h4>{{ username }}</h4>
      <ngb-alert type="success" [dismissible]="false">{{
        "PASSWORD_RESETTED" | translate
      }}</ngb-alert>
    }
    <a
      (click)="back.next(true)"
      [routerLink]="'/login'"
      class="d-block text-center mt-3"
      >
      {{ "BACK_TO_LOGIN" | translate }}
    </a>
  </div>
</app-login-partner-container>
